import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, mergeMap, of } from 'rxjs';
import { EstreamContractStatusService } from 'brain-data/service/brain-estream/estream-contract-status.service';
import {
  loadEstreamContractStatus,
  loadEstreamContractStatusError,
  loadEstreamContractStatusSuccess,
} from '../actions/estream-contract-status.action';

@Injectable()
export class EstreamContractStatusEffects {
  loadEstreamContractStatus$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadEstreamContractStatus),
      mergeMap(({ contractNumber }) =>
        this.service.getStatus(contractNumber).pipe(
          map(status => loadEstreamContractStatusSuccess({ contractNumber, status })),
          catchError((error: Error) =>
            of(loadEstreamContractStatusError({ contractNumber, error })),
          ),
        ),
      ),
    ),
  );

  constructor(
    private actions$: Actions,
    private service: EstreamContractStatusService,
  ) {}
}
